import Vue from 'vue';
import MagicUi from '@/ui';
const components = [];
const svelteComponents = [];
const plugins = [];
const imports = [];

if (window.magicPageComponentsList.LuckyStarSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-lucky-star-svelte',

    loader: () => import(
      /* webpackChunkName: "LuckyStarSvelte" */
      '@tencent/iwan-act-comp-lucky-star-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 LuckyStarSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.IwanPoints) {
  Vue.component('magic-ui-iwan-points', () => import(
    /* webpackChunkName: "IwanPoints" */
    '@tencent/iwan-act-comp-iwan-points/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-points'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-points'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanPoints 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanDownload) {
  Vue.component('magic-ui-iwan-download', () => import(
    /* webpackChunkName: "IwanDownload" */
    '@tencent/iwan-act-comp-iwan-download/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-download'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-download'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanDownload 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanAutoTask) {
  Vue.component('magic-ui-iwan-auto-task', () => import(
    /* webpackChunkName: "IwanAutoTask" */
    '@tencent/iwan-act-comp-iwan-auto-task/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-auto-task'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-auto-task'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanAutoTask 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.Obtain) {
  Vue.component('magic-ui-obtain', () => import(
    /* webpackChunkName: "Obtain" */
    '@tencent/iwan-act-comp-obtain/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-obtain'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-obtain'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 Obtain 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanBoostTemplate) {
  Vue.component('magic-ui-iwan-boost-template', () => import(
    /* webpackChunkName: "IwanBoostTemplate" */
    '@tencent/iwan-act-comp-iwan-boost-template/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-boost-template'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-boost-template'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanBoostTemplate 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanBoostTemplateNgSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-iwan-boost-template-ng-svelte',

    loader: () => import(
      /* webpackChunkName: "IwanBoostTemplateNgSvelte" */
      '@tencent/iwan-act-comp-iwan-boost-template-ng-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 IwanBoostTemplateNgSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.IwanPayVip) {
  Vue.component('magic-ui-iwan-pay-vip', () => import(
    /* webpackChunkName: "IwanPayVip" */
    '@tencent/iwan-act-comp-iwan-pay-vip/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-pay-vip'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-pay-vip'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanPayVip 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTask) {
  Vue.component('magic-ui-iwan-task', () => import(
    /* webpackChunkName: "IwanTask" */
    '@tencent/iwan-act-comp-iwan-task/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-task'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-task'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTask 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanHeader) {
  Vue.component('magic-ui-iwan-header', () => import(
    /* webpackChunkName: "IwanHeader" */
    '@tencent/iwan-act-comp-iwan-header/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-header'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-header'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanHeader 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActSubscribe) {
  Vue.component('magic-ui-act-subscribe', () => import(
    /* webpackChunkName: "ActSubscribe" */
    '@tencent/iwan-act-comp-act-subscribe/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-subscribe'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-subscribe'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActSubscribe 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanHonourBind) {
  Vue.component('magic-ui-iwan-honour-bind', () => import(
    /* webpackChunkName: "IwanHonourBind" */
    '@tencent/iwan-act-comp-iwan-honour-bind/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-honour-bind'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-honour-bind'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanHonourBind 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanIngameTask) {
  Vue.component('magic-ui-iwan-ingame-task', () => import(
    /* webpackChunkName: "IwanIngameTask" */
    '@tencent/iwan-act-comp-iwan-ingame-task/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-ingame-task'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-ingame-task'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanIngameTask 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.RulePop) {
  Vue.component('magic-ui-rule-pop', () => import(
    /* webpackChunkName: "RulePop" */
    '@tencent/iwan-act-comp-rule-pop/src/Rule.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-rule-pop'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-rule-pop'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 RulePop 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTeam) {
  Vue.component('magic-ui-iwan-team', () => import(
    /* webpackChunkName: "IwanTeam" */
    '@tencent/iwan-act-comp-iwan-team/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-team'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-team'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTeam 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanOpenPage) {
  Vue.component('magic-ui-iwan-open-page', () => import(
    /* webpackChunkName: "IwanOpenPage" */
    '@tencent/iwan-act-comp-iwan-open-page/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-open-page'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-open-page'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanOpenPage 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanWxOfficial) {
  Vue.component('magic-ui-iwan-wx-official', () => import(
    /* webpackChunkName: "IwanWxOfficial" */
    '@tencent/iwan-act-comp-iwan-wx-official/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-wx-official'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-wx-official'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanWxOfficial 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanSociatyTable) {
  Vue.component('magic-ui-iwan-sociaty-table', () => import(
    /* webpackChunkName: "IwanSociatyTable" */
    '@tencent/iwan-act-comp-iwan-sociaty-table/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-sociaty-table'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-sociaty-table'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanSociatyTable 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActSigninSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-act-signin-svelte',

    loader: () => import(
      /* webpackChunkName: "ActSigninSvelte" */
      '@tencent/iwan-act-comp-act-signin-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 ActSigninSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.ActReceivingRecord) {
  Vue.component('magic-ui-act-receiving-record', () => import(
    /* webpackChunkName: "ActReceivingRecord" */
    '@tencent/iwan-act-comp-act-receiving-record/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-receiving-record'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-receiving-record'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActReceivingRecord 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActLotteryAwardListProperty) {
  Vue.component('magic-ui-act-lottery-award-list-property', () => import(
    /* webpackChunkName: "ActLotteryAwardListProperty" */
    '@tencent/iwan-act-comp-act-lottery-award-list-property/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-lottery-award-list-property'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-lottery-award-list-property'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActLotteryAwardListProperty 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActHotspotLotteryProperty) {
  Vue.component('magic-ui-act-hotspot-lottery-property', () => import(
    /* webpackChunkName: "ActHotspotLotteryProperty" */
    '@tencent/iwan-act-comp-act-hotspot-lottery-property/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-hotspot-lottery-property'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-hotspot-lottery-property'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActHotspotLotteryProperty 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanBoostNgSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-iwan-boost-ng-svelte',

    loader: () => import(
      /* webpackChunkName: "IwanBoostNgSvelte" */
      '@tencent/iwan-act-comp-iwan-boost-ng-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 IwanBoostNgSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.FilmShow) {
  Vue.component('magic-ui-film-show', () => import(
    /* webpackChunkName: "FilmShow" */
    '@tencent/iwan-act-comp-film-show/src/FilmShow.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-film-show'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-film-show'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 FilmShow 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.VideoSuperVersion) {
  Vue.component('magic-ui-video-super-version', () => import(
    /* webpackChunkName: "VideoSuperVersion" */
    '@tencent/iwan-act-comp-video-super-version'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-video-super-version'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-video-super-version'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 VideoSuperVersion 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanGameList) {
  Vue.component('magic-ui-iwan-game-list', () => import(
    /* webpackChunkName: "IwanGameList" */
    '@tencent/iwan-act-comp-iwan-game-list/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-game-list'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-game-list'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanGameList 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActLotteryRemainTimesProperty) {
  Vue.component('magic-ui-act-lottery-remain-times-property', () => import(
    /* webpackChunkName: "ActLotteryRemainTimesProperty" */
    '@tencent/iwan-act-comp-act-lottery-remain-times-property/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-lottery-remain-times-property'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-lottery-remain-times-property'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActLotteryRemainTimesProperty 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActSignin) {
  Vue.component('magic-ui-act-signin', () => import(
    /* webpackChunkName: "ActSignin" */
    '@tencent/iwan-act-comp-act-signin/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-signin'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-signin'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActSignin 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.MultiObtain) {
  Vue.component('magic-ui-multi-obtain', () => import(
    /* webpackChunkName: "MultiObtain" */
    '@tencent/iwan-act-comp-multi-obtain/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-multi-obtain'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-multi-obtain'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 MultiObtain 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTaskList) {
  Vue.component('magic-ui-iwan-task-list', () => import(
    /* webpackChunkName: "IwanTaskList" */
    '@tencent/iwan-act-comp-iwan-task-list/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-task-list'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-task-list'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTaskList 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanLaunchMiniProgram) {
  Vue.component('magic-ui-iwan-launch-mini-program', () => import(
    /* webpackChunkName: "IwanLaunchMiniProgram" */
    '@tencent/iwan-act-comp-iwan-launch-mini-program/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-launch-mini-program'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-launch-mini-program'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanLaunchMiniProgram 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActBooking) {
  Vue.component('magic-ui-act-booking', () => import(
    /* webpackChunkName: "ActBooking" */
    '@tencent/iwan-act-comp-act-booking/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-booking'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-booking'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActBooking 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActHotspotLotteryPropertySvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-act-hotspot-lottery-property-svelte',

    loader: () => import(
      /* webpackChunkName: "ActHotspotLotteryPropertySvelte" */
      '@tencent/iwan-act-comp-act-hotspot-lottery-property-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 ActHotspotLotteryPropertySvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.Token) {
  Vue.component('magic-ui-token', () => import(
    /* webpackChunkName: "Token" */
    '@tencent/iwan-act-comp-token/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-token'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-token'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 Token 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanPwdExchange) {
  Vue.component('magic-ui-iwan-pwd-exchange', () => import(
    /* webpackChunkName: "IwanPwdExchange" */
    '@tencent/iwan-act-comp-iwan-pwd-exchange/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-pwd-exchange'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-pwd-exchange'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanPwdExchange 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.CombinationItem) {
  Vue.component('magic-ui-combination-item', () => import(
    /* webpackChunkName: "CombinationItem" */
    '@tencent/iwan-act-comp-combination-item'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-combination-item'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-combination-item'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 CombinationItem 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.CombinationContainer) {
  Vue.component('magic-ui-combination-container', () => import(
    /* webpackChunkName: "CombinationContainer" */
    '@tencent/iwan-act-comp-combination-container'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-combination-container'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-combination-container'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 CombinationContainer 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActScrollableContainer) {
  Vue.component('magic-ui-act-scrollable-container', () => import(
    /* webpackChunkName: "ActScrollableContainer" */
    '@tencent/iwan-act-comp-act-scrollable-container/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-scrollable-container'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-scrollable-container'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActScrollableContainer 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanWanhuaContainer) {
  Vue.component('magic-ui-iwan-wanhua-container', () => import(
    /* webpackChunkName: "IwanWanhuaContainer" */
    '@tencent/iwan-act-comp-iwan-wanhua-container/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-wanhua-container'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-wanhua-container'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanWanhuaContainer 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanAddtoDesktop) {
  Vue.component('magic-ui-iwan-addto-desktop', () => import(
    /* webpackChunkName: "IwanAddtoDesktop" */
    '@tencent/iwan-act-comp-iwan-addto-desktop/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-addto-desktop'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-addto-desktop'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanAddtoDesktop 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanPointsSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-iwan-points-svelte',

    loader: () => import(
      /* webpackChunkName: "IwanPointsSvelte" */
      '@tencent/iwan-act-comp-iwan-points-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 IwanPointsSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.IwanJoinHonor) {
  Vue.component('magic-ui-iwan-join-honor', () => import(
    /* webpackChunkName: "IwanJoinHonor" */
    '@tencent/iwan-act-comp-iwan-join-honor/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-join-honor'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-join-honor'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanJoinHonor 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTaskRefresh) {
  Vue.component('magic-ui-iwan-task-refresh', () => import(
    /* webpackChunkName: "IwanTaskRefresh" */
    '@tencent/iwan-act-comp-iwan-task-refresh/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-task-refresh'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-task-refresh'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTaskRefresh 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActZoneRoleSelect) {
  Vue.component('magic-ui-act-zone-role-select', () => import(
    /* webpackChunkName: "ActZoneRoleSelect" */
    '@tencent/iwan-act-comp-act-zone-role-select/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-zone-role-select'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-zone-role-select'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActZoneRoleSelect 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanMsdkOpenvapp) {
  Vue.component('magic-ui-iwan-msdk-openvapp', () => import(
    /* webpackChunkName: "IwanMsdkOpenvapp" */
    '@tencent/iwan-act-comp-iwan-msdk-openvapp/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-msdk-openvapp'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-msdk-openvapp'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanMsdkOpenvapp 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanSmartService) {
  Vue.component('magic-ui-iwan-smart-service', () => import(
    /* webpackChunkName: "IwanSmartService" */
    '@tencent/iwan-act-comp-iwan-smart-service/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-smart-service'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-smart-service'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanSmartService 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanBoostReward) {
  Vue.component('magic-ui-iwan-boost-reward', () => import(
    /* webpackChunkName: "IwanBoostReward" */
    '@tencent/iwan-act-comp-iwan-boost-reward/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-boost-reward'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-boost-reward'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanBoostReward 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanBoostBase) {
  Vue.component('magic-ui-iwan-boost-base', () => import(
    /* webpackChunkName: "IwanBoostBase" */
    '@tencent/iwan-act-comp-iwan-boost-base/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-boost-base'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-boost-base'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanBoostBase 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanPreDownload) {
  Vue.component('magic-ui-iwan-pre-download', () => import(
    /* webpackChunkName: "IwanPreDownload" */
    '@tencent/iwan-act-comp-iwan-pre-download/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-pre-download'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-pre-download'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanPreDownload 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTaskSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-iwan-task-svelte',

    loader: () => import(
      /* webpackChunkName: "IwanTaskSvelte" */
      '@tencent/iwan-act-comp-iwan-task-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 IwanTaskSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.Billboard) {
  Vue.component('magic-ui-billboard', () => import(
    /* webpackChunkName: "Billboard" */
    '@tencent/iwan-act-comp-billboard/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-billboard'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-billboard'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 Billboard 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanVideoAttention) {
  Vue.component('magic-ui-iwan-video-attention', () => import(
    /* webpackChunkName: "IwanVideoAttention" */
    '@tencent/iwan-act-comp-iwan-video-attention/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-video-attention'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-video-attention'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanVideoAttention 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanGift) {
  Vue.component('magic-ui-iwan-gift', () => import(
    /* webpackChunkName: "IwanGift" */
    '@tencent/iwan-act-comp-iwan-gift/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-gift'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-gift'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanGift 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.Vote) {
  Vue.component(
    'magic-ui-vote',
    () => import( /* webpackChunkName: "Vote" */ '@tencent/iwan-act-comp-vote/src/Main.vue').then(({
      default: comp
    }) => {
      window.reportAegisTime?.({
        name: 'vue:resolveEnd',
        ext1: 'magic-ui-vote'.replace(/magic-ui-/, ''),
        ext2: '',
        ext3: window.actId
      });

      MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
      return comp;
    }).catch(err => {
      window.reportAegisTime?.({
        name: 'vue:error',
        ext1: 'magic-ui-vote'.replace(/magic-ui-/, ''),
        ext2: '',
        ext3: window.actId
      });

      console.error('vue 组件 Vote 加载报错: ', err);
    })
  );
}

if (window.magicPageComponentsList.IwanSingleRoundGuess) {
  Vue.component('magic-ui-iwan-single-round-guess', () => import(
    /* webpackChunkName: "IwanSingleRoundGuess" */
    '@tencent/iwan-act-comp-iwan-single-round-guess/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-single-round-guess'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-single-round-guess'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanSingleRoundGuess 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.Guess) {
  Vue.component('magic-ui-guess', () => import(
    /* webpackChunkName: "Guess" */
    '@tencent/iwan-act-comp-guess/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-guess'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-guess'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 Guess 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanHonorEntry) {
  Vue.component('magic-ui-iwan-honor-entry', () => import(
    /* webpackChunkName: "IwanHonorEntry" */
    '@tencent/iwan-act-comp-iwan-honor-entry/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-honor-entry'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-honor-entry'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanHonorEntry 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCoupon) {
  Vue.component('magic-ui-iwan-coupon', () => import(
    /* webpackChunkName: "IwanCoupon" */
    '@tencent/iwan-act-comp-iwan-coupon/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-coupon'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-coupon'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCoupon 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanDownloadIwan) {
  Vue.component('magic-ui-iwan-download-iwan', () => import(
    /* webpackChunkName: "IwanDownloadIwan" */
    '@tencent/iwan-act-comp-iwan-download-iwan/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-download-iwan'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-download-iwan'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanDownloadIwan 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanLoginPc) {
  Vue.component('magic-ui-iwan-login-pc', () => import(
    /* webpackChunkName: "IwanLoginPc" */
    '@tencent/iwan-act-comp-iwan-login-pc/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-login-pc'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-login-pc'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanLoginPc 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCalendarNotify) {
  Vue.component('magic-ui-iwan-calendar-notify', () => import(
    /* webpackChunkName: "IwanCalendarNotify" */
    '@tencent/iwan-act-comp-iwan-calendar-notify/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-calendar-notify'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-calendar-notify'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCalendarNotify 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardShareCard) {
  Vue.component('magic-ui-iwan-collect-card-share-card', () => import(
    /* webpackChunkName: "IwanCollectCardShareCard" */
    '@tencent/iwan-act-comp-iwan-collect-card-share-card/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-share-card'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-share-card'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardShareCard 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardShareButton) {
  Vue.component('magic-ui-iwan-collect-card-share-button', () => import(
    /* webpackChunkName: "IwanCollectCardShareButton" */
    '@tencent/iwan-act-comp-iwan-collect-card-share-button/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-share-button'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-share-button'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardShareButton 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardButtonNext) {
  Vue.component('magic-ui-iwan-collect-card-button-next', () => import(
    /* webpackChunkName: "IwanCollectCardButtonNext" */
    '@tencent/iwan-act-comp-iwan-collect-card-button-next/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-button-next'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-button-next'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardButtonNext 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardImgNext) {
  Vue.component('magic-ui-iwan-collect-card-img-next', () => import(
    /* webpackChunkName: "IwanCollectCardImgNext" */
    '@tencent/iwan-act-comp-iwan-collect-card-img-next/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-img-next'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-img-next'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardImgNext 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.SharePoster) {
  Vue.component('magic-ui-share-poster', () => import(
    /* webpackChunkName: "SharePoster" */
    '@tencent/iwan-act-comp-share-poster/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-share-poster'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-share-poster'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 SharePoster 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanHitCharts) {
  Vue.component('magic-ui-iwan-hit-charts', () => import(
    /* webpackChunkName: "IwanHitCharts" */
    '@tencent/iwan-act-comp-iwan-hit-charts/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-hit-charts'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-hit-charts'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanHitCharts 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.MatchRankSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-match-rank-svelte',

    loader: () => import(
      /* webpackChunkName: "MatchRankSvelte" */
      '@tencent/iwan-act-comp-match-rank-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 MatchRankSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.ActLotteryMarqueeProperty) {
  Vue.component('magic-ui-act-lottery-marquee-property', () => import(
    /* webpackChunkName: "ActLotteryMarqueeProperty" */
    '@tencent/iwan-act-comp-act-lottery-marquee-property/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-lottery-marquee-property'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-lottery-marquee-property'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActLotteryMarqueeProperty 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardRefresh) {
  Vue.component('magic-ui-iwan-collect-card-refresh', () => import(
    /* webpackChunkName: "IwanCollectCardRefresh" */
    '@tencent/iwan-act-comp-iwan-collect-card-refresh/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-refresh'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-refresh'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardRefresh 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanHonorVip) {
  Vue.component('magic-ui-iwan-honor-vip', () => import(
    /* webpackChunkName: "IwanHonorVip" */
    '@tencent/iwan-act-comp-iwan-honor-vip/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-honor-vip'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-honor-vip'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanHonorVip 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanSellCash) {
  Vue.component('magic-ui-iwan-sell-cash', () => import(
    /* webpackChunkName: "IwanSellCash" */
    '@tencent/iwan-act-comp-iwan-sell-cash/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-sell-cash'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-sell-cash'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanSellCash 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.CountDown) {
  Vue.component('magic-ui-count-down', () => import(
    /* webpackChunkName: "CountDown" */
    '@tencent/iwan-act-comp-count-down/src/CountDown.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-count-down'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-count-down'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 CountDown 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.MatchRank) {
  Vue.component('magic-ui-match-rank', () => import(
    /* webpackChunkName: "MatchRank" */
    '@tencent/iwan-act-comp-match-rank/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-match-rank'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-match-rank'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 MatchRank 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.Copy) {
  Vue.component('magic-ui-copy-button', () => import(
    /* webpackChunkName: "Copy" */
    '@tencent/iwan-act-comp-actcopy-button/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-copy-button'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-copy-button'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 Copy 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTeamRank) {
  Vue.component('magic-ui-iwan-team-rank', () => import(
    /* webpackChunkName: "IwanTeamRank" */
    '@tencent/iwan-act-comp-iwan-team-rank/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-team-rank'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-team-rank'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTeamRank 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.QuizzPop) {
  Vue.component('magic-ui-quizz-pop', () => import(
    /* webpackChunkName: "QuizzPop" */
    '@tencent/iwan-act-comp-quizz-pop/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-quizz-pop'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-quizz-pop'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 QuizzPop 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanPointLevel) {
  Vue.component('magic-ui-iwan-point-level', () => import(
    /* webpackChunkName: "IwanPointLevel" */
    '@tencent/iwan-act-comp-iwan-point-level/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-point-level'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-point-level'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanPointLevel 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTeamPkSignup) {
  Vue.component('magic-ui-iwan-team-pk-signup', () => import(
    /* webpackChunkName: "IwanTeamPkSignup" */
    '@tencent/iwan-act-comp-iwan-team-pk-signup/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-team-pk-signup'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-team-pk-signup'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTeamPkSignup 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTeamPkAutoTrigger) {
  Vue.component('magic-ui-iwan-team-pk-auto-trigger', () => import(
    /* webpackChunkName: "IwanTeamPkAutoTrigger" */
    '@tencent/iwan-act-comp-iwan-team-pk-auto-trigger/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-team-pk-auto-trigger'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-team-pk-auto-trigger'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTeamPkAutoTrigger 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTeamPkStatus) {
  Vue.component('magic-ui-iwan-team-pk-status', () => import(
    /* webpackChunkName: "IwanTeamPkStatus" */
    '@tencent/iwan-act-comp-iwan-team-pk-status/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-team-pk-status'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-team-pk-status'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTeamPkStatus 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTeamPkMember) {
  Vue.component('magic-ui-iwan-team-pk-member', () => import(
    /* webpackChunkName: "IwanTeamPkMember" */
    '@tencent/iwan-act-comp-iwan-team-pk-member/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-team-pk-member'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-team-pk-member'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTeamPkMember 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTeamPkPointsBar) {
  Vue.component('magic-ui-iwan-team-pk-points-bar', () => import(
    /* webpackChunkName: "IwanTeamPkPointsBar" */
    '@tencent/iwan-act-comp-iwan-team-pk-points-bar/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-team-pk-points-bar'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-team-pk-points-bar'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTeamPkPointsBar 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanGrowthProcess) {
  Vue.component('magic-ui-iwan-growth-process', () => import(
    /* webpackChunkName: "IwanGrowthProcess" */
    '@tencent/iwan-act-comp-iwan-growth-process/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-growth-process'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-growth-process'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanGrowthProcess 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanGrowthLog) {
  Vue.component('magic-ui-iwan-growth-log', () => import(
    /* webpackChunkName: "IwanGrowthLog" */
    '@tencent/iwan-act-comp-iwan-growth-log/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-growth-log'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-growth-log'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanGrowthLog 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanGrowthBind) {
  Vue.component('magic-ui-iwan-growth-bind', () => import(
    /* webpackChunkName: "IwanGrowthBind" */
    '@tencent/iwan-act-comp-iwan-growth-bind/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-growth-bind'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-growth-bind'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanGrowthBind 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTeamRankSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-iwan-team-rank-svelte',

    loader: () => import(
      /* webpackChunkName: "IwanTeamRankSvelte" */
      '@tencent/iwan-act-comp-iwan-team-rank-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 IwanTeamRankSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.ActCombinationBtn) {
  Vue.component('magic-ui-act-combination-btn', () => import(
    /* webpackChunkName: "ActCombinationBtn" */
    '@tencent/iwan-act-comp-combination-btn'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-combination-btn'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-combination-btn'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActCombinationBtn 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanTeamPk) {
  Vue.component('magic-ui-iwan-team-pk', () => import(
    /* webpackChunkName: "IwanTeamPk" */
    '@tencent/iwan-act-comp-iwan-team-pk/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-team-pk'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-team-pk'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTeamPk 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanLive) {
  Vue.component('magic-ui-iwan-live', () => import(
    /* webpackChunkName: "IwanLive" */
    '@tencent/iwan-act-comp-iwan-live/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-live'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-live'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanLive 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardShareInfo) {
  Vue.component('magic-ui-iwan-collect-card-share-info', () => import(
    /* webpackChunkName: "IwanCollectCardShareInfo" */
    '@tencent/iwan-act-comp-iwan-collect-card-share-info/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-share-info'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-share-info'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardShareInfo 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanRoundsGuess) {
  Vue.component('magic-ui-iwan-rounds-guess', () => import(
    /* webpackChunkName: "IwanRoundsGuess" */
    '@tencent/iwan-act-comp-iwan-rounds-guess/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-rounds-guess'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-rounds-guess'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanRoundsGuess 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.MultiObtainSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-multi-obtain-svelte',

    loader: () => import(
      /* webpackChunkName: "MultiObtainSvelte" */
      '@tencent/iwan-act-comp-multi-obtain-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 MultiObtainSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.IwanTaskPc) {
  Vue.component('magic-ui-iwan-task-pc', () => import(
    /* webpackChunkName: "IwanTaskPc" */
    '@tencent/iwan-act-comp-iwan-task-pc/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-task-pc'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-task-pc'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanTaskPc 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActLotteryRemainTimesPropertySvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-act-lottery-remain-times-property-svelte',

    loader: () => import(
      /* webpackChunkName: "ActLotteryRemainTimesPropertySvelte" */
      '@tencent/iwan-act-comp-act-lottery-remain-times-property-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 ActLotteryRemainTimesPropertySvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.IwanTeamSvelte) {
  svelteComponents.push({
    name: 'iwan-act-comp-iwan-team-svelte',

    loader: () => import(
      /* webpackChunkName: "IwanTeamSvelte" */
      '@tencent/iwan-act-comp-iwan-team-svelte'
    ).then(({
      default: comp
    }) => {
      return comp;
    }).catch(err => {
      console.error('svelte 组件 IwanTeamSvelte 加载报错: ', err);
    })
  });
}

if (window.magicPageComponentsList.IwanPaymentProcess) {
  Vue.component('magic-ui-iwan-payment-process', () => import(
    /* webpackChunkName: "IwanPaymentProcess" */
    '@tencent/iwan-act-comp-iwan-payment-process/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-payment-process'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-payment-process'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanPaymentProcess 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardExchangeInfo) {
  Vue.component('magic-ui-iwan-collect-card-exchange-info', () => import(
    /* webpackChunkName: "IwanCollectCardExchangeInfo" */
    '@tencent/iwan-act-comp-iwan-collect-card-exchange-info/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-exchange-info'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-exchange-info'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardExchangeInfo 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanScrollRecord) {
  Vue.component('magic-ui-iwan-scroll-record', () => import(
    /* webpackChunkName: "IwanScrollRecord" */
    '@tencent/iwan-act-comp-iwan-scroll-record/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-scroll-record'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-scroll-record'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanScrollRecord 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanPcLotteryHotspot) {
  Vue.component('magic-ui-iwan-pc-lottery-hotspot', () => import(
    /* webpackChunkName: "IwanPcLotteryHotspot" */
    '@tencent/iwan-act-comp-iwan-pc-lottery-hotspot/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-pc-lottery-hotspot'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-pc-lottery-hotspot'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanPcLotteryHotspot 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActPointBeforeHandle) {
  Vue.component('magic-ui-act-point-before-handle', () => import(
    /* webpackChunkName: "ActPointBeforeHandle" */
    '@tencent/iwan-act-comp-act-point-before-handle/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-point-before-handle'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-point-before-handle'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActPointBeforeHandle 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanPcSingleGuess) {
  Vue.component('magic-ui-iwan-pc-single-guess', () => import(
    /* webpackChunkName: "IwanPcSingleGuess" */
    '@tencent/iwan-act-comp-iwan-pc-single-guess/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-pc-single-guess'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-pc-single-guess'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanPcSingleGuess 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.PcReceivingRecord) {
  Vue.component('magic-ui-pc-receiving-record', () => import(
    /* webpackChunkName: "PcReceivingRecord" */
    '@tencent/iwan-act-comp-pc-receiving-record/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-pc-receiving-record'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-pc-receiving-record'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 PcReceivingRecord 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ScrollRecord) {
  Vue.component('magic-ui-scroll-record', () => import(
    /* webpackChunkName: "ScrollRecord" */
    '@tencent/iwan-act-comp-scroll-record/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-scroll-record'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-scroll-record'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ScrollRecord 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.AutoCloudgame) {
  Vue.component('magic-ui-auto-cloudgame', () => import(
    /* webpackChunkName: "AutoCloudgame" */
    '@tencent/iwan-act-comp-auto-cloudgame/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-auto-cloudgame'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-auto-cloudgame'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 AutoCloudgame 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanProgress) {
  Vue.component('magic-ui-iwan-progress', () => import(
    /* webpackChunkName: "IwanProgress" */
    '@tencent/iwan-act-comp-iwan-progress/src/Main'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-progress'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-progress'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanProgress 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardButton) {
  Vue.component('magic-ui-iwan-collect-card-button', () => import(
    /* webpackChunkName: "IwanCollectCardButton" */
    '@tencent/iwan-act-comp-iwan-collect-card-button/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-button'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-button'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardButton 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardImg) {
  Vue.component('magic-ui-iwan-collect-card-img', () => import(
    /* webpackChunkName: "IwanCollectCardImg" */
    '@tencent/iwan-act-comp-iwan-collect-card-img/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-img'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-img'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardImg 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardMarquee) {
  Vue.component('magic-ui-iwan-collect-card-marquee', () => import(
    /* webpackChunkName: "IwanCollectCardMarquee" */
    '@tencent/iwan-act-comp-iwan-collect-card-marquee/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-marquee'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-marquee'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardMarquee 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanExchangeCard) {
  Vue.component('magic-ui-iwan-exchange-card', () => import(
    /* webpackChunkName: "IwanExchangeCard" */
    '@tencent/iwan-act-comp-iwan-exchange-card/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-exchange-card'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-exchange-card'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanExchangeCard 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanWidget) {
  Vue.component('magic-ui-iwan-widget', () => import(
    /* webpackChunkName: "IwanWidget" */
    '@tencent/iwan-act-comp-iwan-widget/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-widget'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-widget'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanWidget 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanOpencloudPc) {
  Vue.component('magic-ui-iwan-opencloud-pc', () => import(
    /* webpackChunkName: "IwanOpencloudPc" */
    '@tencent/iwan-act-comp-iwan-opencloud-pc/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-opencloud-pc'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-opencloud-pc'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanOpencloudPc 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanCollectCardMarqueeNext) {
  Vue.component('magic-ui-iwan-collect-card-marquee-next', () => import(
    /* webpackChunkName: "IwanCollectCardMarqueeNext" */
    '@tencent/iwan-act-comp-iwan-collect-card-marquee-next/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-collect-card-marquee-next'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-collect-card-marquee-next'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanCollectCardMarqueeNext 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.QuizCompsNg) {
  Vue.component('magic-ui-quiz-comps-ng-button', () => import(
    /* webpackChunkName: "QuizCompsNg" */
    '@tencent/iwan-act-comp-quiz-comps-ng-button/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-quiz-comps-ng-button'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-quiz-comps-ng-button'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 QuizCompsNg 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.Challenge) {
  Vue.component('magic-ui-challenge', () => import(
    /* webpackChunkName: "Challenge" */
    '@tencent/iwan-act-comp-challenge/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-challenge'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-challenge'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 Challenge 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActPageEnter) {
  Vue.component('magic-ui-act-page-enter', () => import(
    /* webpackChunkName: "ActPageEnter" */
    '@tencent/iwan-act-comp-act-page-enter/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-page-enter'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-page-enter'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActPageEnter 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActPreCreateRole) {
  Vue.component('magic-ui-act-pre-create-role', () => import(
    /* webpackChunkName: "ActPreCreateRole" */
    '@tencent/iwan-act-comp-act-pre-create-role/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-pre-create-role'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-pre-create-role'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActPreCreateRole 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActTaskReport) {
  Vue.component('magic-ui-act-task-report', () => import(
    /* webpackChunkName: "ActTaskReport" */
    '@tencent/iwan-act-comp-act-task-report/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-task-report'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-task-report'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActTaskReport 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.ActTimeLine) {
  Vue.component('magic-ui-act-time-line', () => import(
    /* webpackChunkName: "ActTimeLine" */
    '@tencent/iwan-act-comp-act-time-line/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-act-time-line'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-act-time-line'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 ActTimeLine 加载报错: ', err);
  }));
}

if (window.magicPageComponentsList.IwanInstallReport) {
  Vue.component('magic-ui-iwan-install-report', () => import(
    /* webpackChunkName: "IwanInstallReport" */
    '@tencent/iwan-act-comp-iwan-install-report/src/Main.vue'
  ).then(({
    default: comp
  }) => {
    window.reportAegisTime?.({
      name: 'vue:resolveEnd',
      ext1: 'magic-ui-iwan-install-report'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    MagicUi.hooksMixin && MagicUi.hooksMixin(comp);
    return comp;
  }).catch(err => {
    window.reportAegisTime?.({
      name: 'vue:error',
      ext1: 'magic-ui-iwan-install-report'.replace(/magic-ui-/, ''),
      ext2: '',
      ext3: window.actId
    });

    console.error('vue 组件 IwanInstallReport 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginIwanAct) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginIwanAct" */
    '@tencent/iwan-act-plugin-iwan-act'
  ).then(({
    default: IwanActPluginIwanAct
  }) => {
    plugins.push(IwanActPluginIwanAct);
  }).catch(err => {
    console.error('插件 IwanActPluginIwanAct 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginIwanLoginPc) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginIwanLoginPc" */
    '@tencent/iwan-act-plugin-iwan-login-pc'
  ).then(({
    default: IwanActPluginIwanLoginPc
  }) => {
    plugins.push(IwanActPluginIwanLoginPc);
  }).catch(err => {
    console.error('插件 IwanActPluginIwanLoginPc 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginTxRechargeFloatIcon) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginTxRechargeFloatIcon" */
    '@tencent/iwan-act-plugin-tx-recharge-float-icon'
  ).then(({
    default: IwanActPluginTxRechargeFloatIcon
  }) => {
    plugins.push(IwanActPluginTxRechargeFloatIcon);
  }).catch(err => {
    console.error('插件 IwanActPluginTxRechargeFloatIcon 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginIwanAthena) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginIwanAthena" */
    '@tencent/iwan-act-plugin-iwan-athena'
  ).then(({
    default: IwanActPluginIwanAthena
  }) => {
    plugins.push(IwanActPluginIwanAthena);
  }).catch(err => {
    console.error('插件 IwanActPluginIwanAthena 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginIwanPublicReport) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginIwanPublicReport" */
    '@tencent/iwan-act-plugin-iwan-public-report'
  ).then(({
    default: IwanActPluginIwanPublicReport
  }) => {
    plugins.push(IwanActPluginIwanPublicReport);
  }).catch(err => {
    console.error('插件 IwanActPluginIwanPublicReport 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginIwanScreenResize) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginIwanScreenResize" */
    '@tencent/iwan-act-plugin-iwan-screen-resize'
  ).then(({
    default: IwanActPluginIwanScreenResize
  }) => {
    plugins.push(IwanActPluginIwanScreenResize);
  }).catch(err => {
    console.error('插件 IwanActPluginIwanScreenResize 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginIwanDirectives) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginIwanDirectives" */
    '@tencent/iwan-act-plugin-iwan-directives'
  ).then(({
    default: IwanActPluginIwanDirectives
  }) => {
    plugins.push(IwanActPluginIwanDirectives);
  }).catch(err => {
    console.error('插件 IwanActPluginIwanDirectives 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginIwanLogin) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginIwanLogin" */
    '@tencent/iwan-act-plugin-iwan-login'
  ).then(({
    default: IwanActPluginIwanLogin
  }) => {
    plugins.push(IwanActPluginIwanLogin);
  }).catch(err => {
    console.error('插件 IwanActPluginIwanLogin 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginIwanReport) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginIwanReport" */
    '@tencent/iwan-act-plugin-iwan-report'
  ).then(({
    default: IwanActPluginIwanReport
  }) => {
    plugins.push(IwanActPluginIwanReport);
  }).catch(err => {
    console.error('插件 IwanActPluginIwanReport 加载报错: ', err);
  }));
}

if (window.magicPagePluginsList.IwanActPluginIwanBusinessReport) {
  imports.push(import(
    /* webpackChunkName: "IwanActPluginIwanBusinessReport" */
    '@tencent/iwan-act-plugin-iwan-business-report'
  ).then(({
    default: IwanActPluginIwanBusinessReport
  }) => {
    plugins.push(IwanActPluginIwanBusinessReport);
  }).catch(err => {
    console.error('插件 IwanActPluginIwanBusinessReport 加载报错: ', err);
  }));
}

export {
  components,
  plugins,
  svelteComponents
};
export default imports;
